import React, { Component } from "react";
import { Route, Redirect } from 'react-router'
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Divider,
  Switch,
  TextField,
  Typography,
  colors
} from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { toast } from "react-toastify";
import axios from "axios";
import { TablePagination } from 'react-pagination-table';
import _apiData from "../../metaData";
let apiData = _apiData[0];
console.log(apiData, "apiData");

const TableHeader = ["Client Name", "Email", "Mobile Number", "Active Agents", "Blocked Agents", "Total Agents", "Actions"];

export default class EditUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agentRole: "",
      searchText: "Search",
      searchData: {},
      showDetails: false,
      fullUserList: null,
      userList: null,
      clientList: null,
      clients: null,
      client_filter: ""
    };
  }

  componentDidMount(){
    let client = JSON.parse(localStorage.getItem("loginDetails")).user.clientId
    axios.get(apiData.client_list.url, {
        params: {
          work_order: apiData.client_list.params.work_order,
          client_id: client
        },
        headers: apiData.headers
      })
      .then(res => {
        if(res.data.ok){
            let clientList = res.data.response.finalClientList.map(item => {
              return {
                ...item,
                Actions: <div style={{display: 'flex', justifyContent: 'space-around'}}><div onClick={() => this.handleEdit(item.email)} style={{backgroundColor: "#e8796a", color: 'white', padding: '4px', borderRadius: '3px'}}><EditIcon/></div> <div onClick={() => this.handleDelete(item.email)} style={{backgroundColor: "#e8796a", color: 'white', padding: '4px', borderRadius: '3px'}}><DeleteIcon/></div></div>
              }
            })
            this.setState({clientList})
        }
      })
  }

  handleAddNew() {
    this.props.history.push("/addClient")
  }

  handleEdit(email) {
    this.props.history.push({
      pathname: "/editClient",
      state: {email} 
    })
  }

  handleDelete(email) {
    this.props.history.push({
      pathname: "/deleteClient",
      state: {email} 
    })
  }

  submitAgent(e) {
    if (!this.state.agentRole) {
      toast.error("Please Select Role!", {
        position: toast.POSITION.TOP_RIGHT
      });
    } else {
      console.log("submit..");
      let data = {};
      data.username = this.state.searchData.userName;
      data.user_type = this.state.agentRole;
      axios
        .put(apiData.userDetails.url, data, {
          headers: apiData.headers
        })
        .then(res => {
          console.log(res, "submit put res");
          if (res.data.ok) {
            toast.success("Edited Sucessfully!", {
              position: toast.POSITION.TOP_RIGHT
            });
            this.setState({
              showDetails: false,
              agentRole: ""
            });
          } else {
            toast.error(
              res.data.error.reason
                ? res.data.error.reason
                : "User Not Found !",
              {
                position: toast.POSITION.TOP_RIGHT
              }
            );
          }
        });
    }
  }
  searchClick(e) {
    console.log(this.state.searchMobile, "mobile");
    this.setState({
      searchText: "Loading..."
    });
    if (this.state.searchMobile) {
      let params = {};
      params.username = this.state.searchMobile;
      console.log(params, "paraaamss");
      axios
        .get(apiData.userDetails.url, {
          params: { username: this.state.searchMobile },
          headers: apiData.headers
        })
        .then(res => {
          console.log(res, "ress");
          this.setState({
            searchText: "Search"
          });
          if (res.data.ok) {
            console.log(res.data.response.userObj, "res.dataoop");
            let response = res.data.response.userObj;
            let showObj = {};
            showObj.mobile = response.primary_phone
              ? response.primary_phone
              : "-";
            showObj.email = response.email ? response.email : "-";
            showObj.firstName = response.first_name;
            showObj.lastName = response.last_name;
            showObj.userType = response.user_type;
            showObj.userName = response.username;
            showObj.clientName = response.client_name
              ? response.client_name
              : "-";
            showObj.apps = response.assigned_apps;
            showObj.projects = response.assigned_prefixCodes;
            console.log(showObj, "showObj");
            this.setState({
              searchData: showObj,
              showDetails: true
            });
          } else {
            this.setState({
              showDetails: false
            });
            toast.error(
              res.data.error.reason
                ? res.data.error.reason
                : "User Not Found !",
              {
                position: toast.POSITION.TOP_RIGHT
              }
            );
          }
        });
    } else {
      toast.error("Please Enter Mobile/UserName !", {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  }

  clientFilter = (e) => {
    if(e.target.value === "All Clients"){
      this.setState({userList: this.state.fullUserList})
    } else {
      let filteredList = this.state.fullUserList.filter(item => item.clientName === e.target.value);
      this.setState({userList: filteredList})
    }
  }

  render() {
    console.log(this.state.agentRole, "agentRole");
    console.log(this.state.userList)
    return (
      <div className="container hole-container" style={{ width: "76em" }}>
        <h6 className="page-header">List Clients</h6>
        <div className="row">
          <div class="form-group row col-md-10" style={{display: 'flex', alignItems: 'center'}}>
            
          </div>
          <div className="col-md-2">
            <Button
              variant="contained"
              color="primary"
              component="span"
              onClick={() => this.handleAddNew()}
              style={{background: "#e8796a"}}
            >
              + Add New
            </Button>
          </div>
        </div>

        {/* <div className="row">
            {this.state.userList && <div class="form-group row col-md-10" style={{display: 'flex', alignItems: 'center'}}>
              <label className='col-sm-2 label' for="sel1">Client</label>
              <div className='col-sm-3'>
                <select class="form-control" id="sel1" onChange={this.clientFilter}>
                  {this.state.clients.map(item => {
                    return <option value={item} selected={this.state.client_filter == {item} ? 'selected' : ""}>{item}</option>
                  })}
                </select>
              </div>
            </div>}
          <div className="col-md-2">
            
          </div>
        </div> */}

        {this.state.clientList && <div style={{marginTop: '20px', marginBottom: '20px'}}>
	        <TablePagination
              title=""
              // subTitle="Sub Title"
              headers={ TableHeader }
              data={ this.state.clientList }
              columns="client_name.email.mobile_number.active_agents.blocked_agents.total_agents.Actions"
              perPageItemCount={ 50 }
              totalCount={ this.state.clientList.length }
              // arrayOption={ [["size", 'all', ' ']] }
	          paginationClassName="pagination"
            />
	    </div>}
      </div>
    );
  }
}
